import { useEffect } from 'react';

function useOnFocus(elementReference, handler) {

  useEffect(function registerForEvents() {

    const element = elementReference.current;

    if (element === null) {
      return;
    }

    element.focus();

  }, [elementReference.current]);

}

export default useOnFocus;